import platform from "../../../util/platform";
const getConfigOverviews = () => {
    return (params) => {
        const path = `/admin/app/overviews`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAppByHostname = (hostname) => {
    return (params) => {
        const path = `/admin/app/hostname/${hostname}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const updateProductSettings = (vendor, productSettings) => {
    return (params) => {
        const path = `/admin/app/vendor/${vendor}/update/product`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, productSettings);
    };
};
const updateNotificationSettings = (vendor, notificationSettings) => {
    return (params) => {
        const path = `/admin/app/vendor/${vendor}/update/notification`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, notificationSettings);
    };
};
const app = {
    getConfigOverviews,
    getAppByHostname,
    updateProductSettings,
    updateNotificationSettings,
};
export default app;
